import { BUFFER_MARGIN, MARGIN_BETWEEN_BRANCH_NODES, CARD_WIDTH } from 'automation-ui-flow-core/canvas/graphConstants';
/**
 * Given the estimated center coordinates of a node, its width and
 * height, and the optional bufferMargin, calculate the
 * four edge positions (y-min or top edge, y-max or bottom edge,
 * x-min or left edge, x-max or right edge). This
 * is used to determine whether to show the node or not
 * once the canvas scroll frame is determined.
 */
const calculateDrawFrameBoundForNode = ({
  estimatedPosition,
  nodeWrapperHeight,
  nodeWrapperWidth,
  bufferMargin = BUFFER_MARGIN
}) => {
  const nodeWidth = CARD_WIDTH + MARGIN_BETWEEN_BRANCH_NODES;
  const rightEdge = estimatedPosition.x + nodeWrapperWidth / 2 + nodeWidth / 2 + bufferMargin;
  const leftEdge = estimatedPosition.x - nodeWrapperWidth / 2 - nodeWidth / 2;
  const bottomEdge = estimatedPosition.y + nodeWrapperHeight + bufferMargin;
  const topEdge = estimatedPosition.y;
  return {
    leftEdge,
    rightEdge,
    topEdge,
    bottomEdge
  };
};
export default calculateDrawFrameBoundForNode;